module.exports = __webpack_public_path__ + "fonts/SFUIText-RegularItalic.4d5849c5.woff2";